function getRect(element) {
  return element?.getBoundingClientRect();
}
function getTranslate(placement, target, arrow) {
  const defaultTranslate = `translate3d(0, 0, 0)`;
  if (!target || !arrow) return defaultTranslate;
  const centerX = target.x + target.width / 2;
  const arrowX = arrow.x + arrow.width / 2;
  switch (placement) {
    case "top":
    case "bottom": {
      if (arrow.width < target.width) return defaultTranslate;
      const x = centerX - arrowX;
      return `translate3d(${x}px, 0, 0)`;
    }
    default:
      return "";
  }
}
function hasCorrectPosition(placement, target, arrow) {
  if (!arrow || !target) return true;
  switch (placement) {
    case "top":
      return arrow.y < target.y;
    case "bottom":
      return arrow.y > target.y;
    case "left":
      return arrow.x < target.x;
    case "right":
      return arrow.x > target.x;
  }
}
function computeLeft(size, placement) {
  switch (placement) {
    case "top":
    case "bottom":
      return `calc(50% - ${size / 2}px)`;
    case "left":
    case "right":
      return -size / 2;
  }
}
function computeTop(size, placement) {
  switch (placement) {
    case "top":
    case "bottom":
      return -size / 2;
    case "left":
    case "right":
      return `calc(50% - ${size / 2}px)`;
  }
}
function computeMargin(size, placement) {
  const triangleHeight = Math.sqrt(3) * size / 2;
  const space = `${Math.floor(triangleHeight)}px`;
  switch (placement) {
    case "top":
      return `0 0 ${space} 0`;
    case "bottom":
      return `${space} 0 0  0`;
    case "left":
      return `0 ${space} 0  0`;
    case "right":
      return `0 0 0 ${space}`;
  }
}
function computeArrowShadow(placement) {
  const shadowColor = "rgba(0,0,0,0.3)";
  switch (placement) {
    case "left":
      return `1px 0px 5px 1px ${shadowColor}`;
    case "right":
      return `2px 0px 7px 2px ${shadowColor}`;
    case "top":
      return `0px 0px 7px 3px ${shadowColor}`;
    case "bottom":
      return `0px 0px 6px 0px ${shadowColor}`;
  }
}
export {
  computeArrowShadow,
  computeLeft,
  computeMargin,
  computeTop,
  getRect,
  getTranslate,
  hasCorrectPosition
};
//# sourceMappingURL=utils.js.map
